var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OrderStep } from './orderStep';
import { OrderMenu } from './order-menu';
import { Order, OrderType } from './order';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
var CurrentOrderService = (function () {
    function CurrentOrderService() {
        this._order = new BehaviorSubject(new Order());
        this.order = this._order.asObservable();
        this._orderType = new BehaviorSubject(new OrderType());
        this.orderType = this._orderType.asObservable();
        this._orderMenuVisibility = new BehaviorSubject(new OrderMenu());
        this.orderMenuVisibility = this._orderMenuVisibility.asObservable();
        this._orderStep = new BehaviorSubject(new OrderStep());
        this.orderStep = this._orderStep.asObservable();
        this.resetAll();
    }
    CurrentOrderService.prototype.setMenuVisibility = function (orderMenu) {
        this._orderMenuVisibility.next(orderMenu);
    };
    CurrentOrderService.prototype.setOrderType = function (newOrderType) {
        var actual = this._orderType.getValue();
        this._orderType.next(Object.assign(actual, newOrderType));
    };
    CurrentOrderService.prototype.setOrder = function (newOrder) {
        this._order.next(newOrder);
    };
    CurrentOrderService.prototype.resetOrderType = function () {
        this._orderType.next({
            uppercaseType: "",
            uppercaseLabel: "",
            lowercaseType: "",
            lowercaseLabel: ""
        });
    };
    CurrentOrderService.prototype.resetOrderStep = function () {
        this._orderStep.next({
            partValidity: false,
            addressValidity: false,
            billingValidity: false,
            shippingValidity: false
        });
    };
    CurrentOrderService.prototype.resetMenu = function () {
        this._orderMenuVisibility.next({
            part: false,
            address: false,
            billing: false,
            shipping: false,
            summary: false,
            completed: false
        });
    };
    CurrentOrderService.prototype.resetAll = function () {
        this.resetOrderType();
        this.resetOrder();
        this.resetMenu();
        this.resetOrderStep();
    };
    CurrentOrderService.prototype.generateUUID = function () {
        var d = new Date().getTime();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
            d += performance.now(); //use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    };
    // Les resets sont tous séparés pour permettre de juste reset l'élément qu'on veut, par exemple dans orderCompleted, on reset que la commande en cours, mais pas le type
    //sinon le UI ne marche plus.
    CurrentOrderService.prototype.resetOrder = function () {
        this._order.next({
            id: this.generateUUID(),
            uptimeId: "",
            PromoCode: "",
            orderType: "",
            PurchaseOrderNumber: "",
            POfile: null,
            POfileName: null,
            POfileKey: null,
            POfileURL: null,
            IsPartialDelivery: false,
            IsBillingAddressSame: true,
            Items: [],
            QuestionComment: "",
            CourierName: "",
            OtherCourierName: "",
            CourierAccountNumber: "",
            DeliveryMethod: "",
            Brand: {
                Id: "",
                Name: "",
                Order: 0
            },
            ShippingMethod: "",
            Status: {
                Id: "",
                Name: ""
            },
            Contact: {
                FirstName: "",
                LastName: "",
                JobTitle: "",
                Phone: "",
                Email: "",
                AccountId: null,
                CompanyName: ""
            },
            ShippingAddress: {
                Line: "",
                City: "",
                Country: {
                    Id: "",
                    Name: "",
                    ShortName: ""
                },
                StateProvince: "",
                PostalCode: "",
                TypeId: null,
                AccountId: null,
            },
            BillingAddress: {
                Line: "",
                City: "",
                Country: {
                    Id: "",
                    Name: "",
                    ShortName: ""
                },
                StateProvince: "",
                PostalCode: "",
                TypeId: null,
                AccountId: null,
            }
        });
    };
    CurrentOrderService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], CurrentOrderService);
    return CurrentOrderService;
}());
export { CurrentOrderService };
//# sourceMappingURL=currentOrder.service.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/currentOrder.service.js
// module id = 15
// module chunks = 0